export const PLANNER_REMINDER_PREFERENCES_ENTITY_TYPE='planner_reminder_preferences';

export const DEFAULT_PLANNER_REMINDER_PREFERENCES=Object.freeze({
  enabled:false,
  preparationEnabled:true,
  curingEnabled:true,
  dryingEnabled:true,
  prepareSmokerEnabled:true,
  prepareSmokerLeadMinutes:30,
  liveStartEnabled:true,
  liveStartLeadMinutes:10
});

function bool(value,fallback){
  return typeof value==='boolean'?value:fallback;
}

function lead(value,label,{max=240}={}){
  const number=Number(value);
  if(!Number.isInteger(number)||number<0||number>max){
    throw new TypeError(label+' must be an integer between 0 and '+max);
  }
  return number;
}

export function normalisePlannerReminderPreferences(value={}){
  const source=value&&typeof value==='object'?value:{};
  return Object.freeze({
    enabled:bool(source.enabled,DEFAULT_PLANNER_REMINDER_PREFERENCES.enabled),
    preparationEnabled:bool(source.preparationEnabled,DEFAULT_PLANNER_REMINDER_PREFERENCES.preparationEnabled),
    curingEnabled:bool(source.curingEnabled,DEFAULT_PLANNER_REMINDER_PREFERENCES.curingEnabled),
    dryingEnabled:bool(source.dryingEnabled,DEFAULT_PLANNER_REMINDER_PREFERENCES.dryingEnabled),
    prepareSmokerEnabled:bool(source.prepareSmokerEnabled,DEFAULT_PLANNER_REMINDER_PREFERENCES.prepareSmokerEnabled),
    prepareSmokerLeadMinutes:lead(
      source.prepareSmokerLeadMinutes??DEFAULT_PLANNER_REMINDER_PREFERENCES.prepareSmokerLeadMinutes,
      'prepareSmokerLeadMinutes'
    ),
    liveStartEnabled:bool(source.liveStartEnabled,DEFAULT_PLANNER_REMINDER_PREFERENCES.liveStartEnabled),
    liveStartLeadMinutes:lead(
      source.liveStartLeadMinutes??DEFAULT_PLANNER_REMINDER_PREFERENCES.liveStartLeadMinutes,
      'liveStartLeadMinutes',
      {max:120}
    )
  });
}

export function createPlannerReminderPreferenceStore({
  repository,
  userId,
  now=()=>new Date().toISOString()
}={}){
  if(!repository?.get||!repository?.put)throw new TypeError('repository with get/put is required');
  const owner=String(userId||'').trim();
  if(!owner)throw new TypeError('userId is required');

  async function get(){
    const row=await repository.get(PLANNER_REMINDER_PREFERENCES_ENTITY_TYPE,owner);
    if(!row)return DEFAULT_PLANNER_REMINDER_PREFERENCES;
    if(row.userId!==owner)throw new Error('PLANNER_REMINDER_PREFERENCES_OWNER_MISMATCH');
    return normalisePlannerReminderPreferences(row);
  }

  async function save(changes={}){
    const current=await get();
    const value=normalisePlannerReminderPreferences({...current,...changes});
    await repository.put(PLANNER_REMINDER_PREFERENCES_ENTITY_TYPE,{
      id:owner,
      userId:owner,
      ...value,
      updatedAt:now()
    });
    return value;
  }

  async function disable(){return save({enabled:false});}

  return Object.freeze({get,save,disable});
}
